import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import MicrophoneButton from "../MicrophoneButton";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

const SpeechModule = ({ sendSpeechResponse, displaySpeechResponse }) => {
  const [isRecording, setIsRecording] = useState(false);
  const recognitionRef = useRef(null);

  recognitionRef.current = new SpeechRecognition();
  recognitionRef.current.lang = "en-US";
  recognitionRef.current.interimResults = true;

  const startStopSpeechRecognition = () => {
    if (isRecording) {
      setIsRecording(false);
      recognitionRef.current.stop();
    } else {
      setIsRecording(true);
      recognitionRef.current.start();
    }

    recognitionRef.current.onresult = event => {
      const last = event.results.length - 1;
      if (event.results[last].isFinal) {
        sendSpeechResponse(event.results[last][0].transcript, "customer");
      } else {
        displaySpeechResponse(event.results[last][0].transcript, "customer");
      }
    };

    recognitionRef.current.onspeechend = () => {
      recognitionRef.current.stop();
      setIsRecording(false);
    };

    recognitionRef.current.onnomatch = () => {
      sendSpeechResponse("Sorry, Please try again.", "dpz");
      setIsRecording(false);
    };

    recognitionRef.current.onerror = () => {
      sendSpeechResponse("Sorry, Please try again.", "dpz");
      setIsRecording(false);
    };
  };

  return (
    <MicrophoneButton
      isRecording={isRecording}
      startStopSpeechRecognition={startStopSpeechRecognition}
    />
  );
};

SpeechModule.propTypes = {
  displaySpeechResponse: PropTypes.func.isRequired,
  sendSpeechResponse: PropTypes.func.isRequired
};

export default SpeechModule;
